import * as React from "react";
import { cn } from "@/lib/utils";

// AppBar Root Component
const AppBar = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"div">
>(({ className, ...props }, ref) => {
  return (
    <div
      data-slot="app-bar"
      className={cn("wl-page-header", className)}
      ref={ref}
      {...props}
    />
  );
});
AppBar.displayName = "AppBar";

// AppBar Navigation Component
const AppBarNavigation = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"div">
>(({ className, ...props }, ref) => {
  return (
    <div
      data-slot="app-bar-navigation"
      className={cn("wl-header-navigation", className)}
      ref={ref}
      {...props}
    />
  );
});
AppBarNavigation.displayName = "AppBarNavigation";

// AppBar Content Component
const AppBarContent = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"div">
>(({ className, ...props }, ref) => {
  return (
    <div
      data-slot="app-bar-content"
      className={cn("wl-header-content", className)}
      ref={ref}
      {...props}
    />
  );
});
AppBarContent.displayName = "AppBarContent";

// AppBar Title Container Component
const AppBarTitleContainer = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"div">
>(({ className, ...props }, ref) => {
  return (
    <div
      data-slot="app-bar-title-container"
      className={cn("wl-header-title-container", className)}
      ref={ref}
      {...props}
    />
  );
});
AppBarTitleContainer.displayName = "AppBarTitleContainer";

// AppBar Title Component
const AppBarTitle = React.forwardRef<
  HTMLHeadingElement,
  React.ComponentProps<"h1">
>(({ className, ...props }, ref) => {
  return (
    <h1
      data-slot="app-bar-title"
      className={cn("wl-header-title", className)}
      ref={ref}
      {...props}
    />
  );
});
AppBarTitle.displayName = "AppBarTitle";

// AppBar Subtitle Component
const AppBarSubtitle = React.forwardRef<
  HTMLParagraphElement,
  React.ComponentProps<"p">
>(({ className, ...props }, ref) => {
  return (
    <p
      data-slot="app-bar-subtitle"
      className={cn("wl-header-subtitle", className)}
      ref={ref}
      {...props}
    />
  );
});
AppBarSubtitle.displayName = "AppBarSubtitle";

// AppBar Actions Component
const AppBarActions = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"div">
>(({ className, ...props }, ref) => {
  return (
    <div
      data-slot="app-bar-actions"
      className={cn("wl-header-actions", className)}
      ref={ref}
      {...props}
    />
  );
});
AppBarActions.displayName = "AppBarActions";

// AppBar Modal Header Component
const AppBarModalHeader = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"div">
>(({ className, ...props }, ref) => {
  return (
    <div
      data-slot="app-bar-modal-header"
      className={cn("wl-page-modal-header", className)}
      ref={ref}
      {...props}
    />
  );
});
AppBarModalHeader.displayName = "AppBarModalHeader";

export {
  AppBar,
  AppBarNavigation,
  AppBarContent,
  AppBarTitleContainer,
  AppBarTitle,
  AppBarSubtitle,
  AppBarActions,
  AppBarModalHeader,
}; 